module.exports = __webpack_public_path__ + "static/media/textCurto.cbad3b5c.svg";